import loginService from '../login.service';
import pageTrackingService from '../marketing/page.tracking.service';

import { PAGE_TRACKING_APPLICATION_NAME } from '../../constant/marketing/page.tracking.constant';
import { TRIAGE_BRIEFING_FEEDBACK_EVENT, TRIAGE_BRIEFING_OPEN_EVENT } from '../../constant/crm/crm.triage.briefing.constant';

const cardFieldsOf = ({ opportunityId, profile, hasAnalysis, surface }) => ({
    opportunityId: opportunityId ?? '',
    profile: profile || '',
    hasAnalysis: !!hasAnalysis,
    surface: surface || '',
});

const saveCardEvent = (eventType, additional) =>
    pageTrackingService.save({
        applicationName: PAGE_TRACKING_APPLICATION_NAME,
        eventType,
        pageUrl: window.location.href,
        pathName: window.location.pathname,
        userId: loginService.getUserAuthentication()?.id || null,
        additional,
    }).catch(() => null);

const trackOpen = (card) => saveCardEvent(TRIAGE_BRIEFING_OPEN_EVENT, cardFieldsOf(card));

const trackFeedback = (card) => saveCardEvent(TRIAGE_BRIEFING_FEEDBACK_EVENT, { ...cardFieldsOf(card), useful: card.useful === true });

const crmTriageBriefingTrackingService = {
    trackOpen,
    trackFeedback,
};

export default crmTriageBriefingTrackingService;
